import ChatBox from './index.vue';
ChatBox.install = Vue => Vue.component(ChatBox.name, ChatBox);

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(ChatBox);
}

export default ChatBox


// WEBPACK FOOTER //
// ./src/packages/chatBox/index.js